export * from './pt-en.urls';
